const APP_VERSION = '1783019040437';
export default APP_VERSION;
